import { HttpClient } from '@angular/common/http';
import { computed, inject, Injectable, resource } from '@angular/core';
import { TenantService } from '@cmi/addin-core';
import { firstValueFrom } from 'rxjs';

export interface ServerVersionInfo {
  version: string;
}

@Injectable({ providedIn: 'root' })
export class ServerVersionService {
  private readonly _http = inject(HttpClient);
  private readonly _tenantService = inject(TenantService);

  private readonly _versionResource = resource<ServerVersionInfo, { tenant: string | null }>({
    params: () => ({ tenant: this._tenantService.selectedTenantName() }),
    loader: async ({ params }) => {
      if (!params.tenant) {
        return { version: '' };
      }

      return firstValueFrom(
        this._http.get<ServerVersionInfo>('/api/core/ServerInfo/ServerVersion')
      );
    }
  });

  public readonly version = computed(() => this._versionResource.value()?.version ?? '');
  public readonly isLoading = computed(() => this._versionResource.isLoading());
  public readonly error = computed(() => this._versionResource.error());
}
